/**
 * @module footnote/footnoteediting
 */

import { Plugin } from 'ckeditor5/src/core';
import { toWidget, viewToModelPositionOutsideModelElement } from 'ckeditor5/src/widget';
import FootnoteCommand from './footnotecommand';
import { createFootnoteElement } from './utils';

const FIELD = 'footnote';

/**
 * The footnote editing.
 *
 * Introduces the `'footnote'` model element.
 *
 * @extends {Plugin}
 */
export default class FootnoteEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'FootnoteEditing';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
		const config = editor.config.get( FIELD ) || {};
		/**
		 * @type {boolean}
		 */
		this._edit = config.edit && true || false;
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;

		this._defineSchema();
		this._defineConverters();

		editor.commands.add( 'footnote', new FootnoteCommand( editor ) );

		this.editor.editing.mapper.on(
			'viewToModelPosition',
			viewToModelPositionOutsideModelElement( this.editor.model, viewElement => viewElement.hasClass( FIELD ) )
		);
	}

	/**
	 * @private
	 */
	_defineSchema() {
		const schema = this.editor.model.schema;
		schema.register( FIELD, {
			allowWhere: '$text',
			isInline: true,
			isObject: true,
			allowAttributesOf: '$text',
			allowAttributes: [ 'value' ]
		} );
	}

	/**
	 * @private
	 */
	_defineConverters() {
		const conversion = this.editor.conversion;
		conversion.for( 'upcast' ).elementToElement( {
			view: {
				name: 'span',
				classes: [ FIELD ]
			},
			model: ( viewElement, { writer: modelWriter } ) => {
				const value = viewElement.getChild( 0 ).data;
				return modelWriter.createElement( FIELD, { value } );
			},
		} );

		conversion.for( 'editingDowncast' ).elementToElement( {
			model: FIELD,
			view: ( modelItem, { writer: viewWriter } ) => toWidget( createFootnoteElement( modelItem, viewWriter, true ), viewWriter )
		} );

		conversion.for( 'dataDowncast' ).elementToElement( {
			model: FIELD,
			view: ( modelItem, { writer: viewWriter } ) => createFootnoteElement( modelItem, viewWriter, false )
		} );
	}

}
